<template>
    <div class='competitionAdd'>
        <div class="add" v-show="!isPreview">
            <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="100px" class="demo-ruleForm content">
                <el-form-item label="竞赛类别：" prop="type">
                    <el-select v-model="ruleForm.type" placeholder="请选择">
                        <el-option v-for="(item,index) in typeOption" :label="item.label" :value="item.value"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="赛事名称：" prop="name">
                    <el-input v-model="ruleForm.name" placeholder="请输入赛事名称"></el-input>
                </el-form-item>
                <el-form-item label="奖项等级：" prop="degree">
                    <el-select v-model="ruleForm.degree" placeholder="请选择">
                        <el-option v-for="(item,index) in degreeOption" :label="item.label" :value="item.value" :key="index"></el-option>
                    </el-select>
                </el-form-item>

                <el-form-item label="获奖时间：" prop="date">
                    <el-date-picker type="date"  value-format="yyyy-MM-dd" placeholder="请选择日期" v-model="ruleForm.date" style="width: 100%;"></el-date-picker>
                </el-form-item>

                <el-form-item label="组织单位：" prop="organizationalUnit" >
                    <el-input v-model="ruleForm.organizationalUnit" placeholder="请输入组织单位名称"></el-input>
                </el-form-item>
                <el-form-item label="奖项类型：" prop="personalTeam">
                    <el-select v-model="ruleForm.personalTeam" placeholder="请选择">
                        <el-option v-for="(item,index) in personalTeamOption" :label="item.label" :value="item.value" :key="index"></el-option>
                    </el-select>
                </el-form-item>
                <div class="line">
                    上传相关图片：
                    <span>（2M以内，最多5张，支持jpg/png）</span>
                </div>
                <div>
                    <el-upload
                        :on-change="handleChange"
                        action="#"
                        :limit="5"
                        list-type="picture-card"
                        :auto-upload="false"
                        :file-list="ruleForm.picUrl"
                        :on-preview="handlePictureCardPreview"
                        :on-remove="handleRemove"
                        :multiple="true"
                        accept="image/jpeg,image/jpg,image/png"
                    >
                        <i slot="default" class="el-icon-plus"></i>
                    </el-upload>
                    <el-dialog :visible.sync="dialogVisible">
                        <img width="100%" :src="dialogImageUrl" alt="">
                    </el-dialog>
                </div>
            </el-form>
            <div class="btnBox" style="display: flex;justify-content: space-around;padding: 45px 0px;width: 300px;margin: 0px auto;">
                <Button @handleClick="submitForm('ruleForm',true)" name="预览" :type="'btnGray'"></Button>
                <Button @handleClick="submitForm('ruleForm',false)" :type="'btnBlue'" name="保存" ></Button>
            </div>
        </div>
        <div class="detail" v-show="isPreview">
            <CompetitionDetail :form="ruleForm"></CompetitionDetail>
            <div class="btnBox" style="display: flex;justify-content: space-around;padding: 45px 0px;width: 300px;margin: 0px auto;">
                <Button @handleClick="isPreview=false" :type="'btnGray'" name="返回" ></Button>
            </div>
        </div>
    </div>
</template>
<script>
import Button from '@/components/Button.vue'
import CompetitionDetail from '@/components/consultant/CompetitionDetail.vue'
export default {
    name: "competitionAdd",
    components: {
        Button,
        CompetitionDetail
    },
    data() {
        return {
            isPreview: false,
            typeOption:[
                { label: '五大学科类', value: '1' },
                { label: '科技创新类', value: '2' },
                { label: '人文社科类', value: '3' },
                { label: '国际赛事类', value: '4' },
                { label: '其他', value: '5' }
            ],
            degreeOption:[
                { label: '市级一等奖', value: '市级一等奖' },
                { label: '市级二等奖', value: '市级二等奖' },
                { label: '市级三等奖', value: '市级三等奖' },
                { label: '省级一等奖', value: '省级一等奖' },
                { label: '省级二等奖', value: '省级二等奖' },
                { label: '省级三等奖', value: '省级三等奖' },
                { label: '国家一等奖', value: '国家一等奖' },
                { label: '国家二等奖', value: '国家二等奖' },
                { label: '国家三等奖', value: '国家三等奖' },
                { label: '国际一等奖', value: '国际一等奖' },
                { label: '国际二等奖', value: '国际二等奖' },
                { label: '国际三等奖', value: '国际三等奖' },
                { label: '国际四等奖', value: '国际四等奖' },
                { label: '参与奖', value: '参与奖' },
            ],
            personalTeamOption:[
                { label: '团体', value: '1' },
                { label: '个人', value: '2' }
            ],
            dialogImageUrl: '',
            dialogVisible: false,
            disabled: false,
            // file: null,
            isSave: false,

            previewVisible: false,
            previewImage: '',
            previewTitle: '',
            studentId: sessionStorage.getItem('myStudentStudentId'),
            ruleForm: {
                type: '',//1五大学科类 2科技创新类 3人文社科类 4国际赛事类 5其他
                name: '',//赛事名称
                degree: '',//奖项等级
                date: null,//获奖日期
                organizationalUnit: '',//组织单位
                personalTeam: '',//奖项类型 1个人 2团体
                // fileList: [],
                picUrl: []//上传图片

            },
            rules: {
                type: [
                    { required: true, message: '请选择竞赛类别', trigger: 'blur' },
                ],
                name: [
                    { required: true, message: '请输入赛事名称', trigger: 'blur' },
                ],
                degree: [
                    { required: true, message: '请选择奖项等级', trigger: 'blur' },
                ],
                date: [
                    { required: true, message: '请选择获奖时间', trigger: 'blur' },
                ],
                organizationalUnit: [
                    { required: true, message: '请输入组织单位名称', trigger: 'blur' },
                ],
                personalTeam: [
                    { required: true, message: '请选择奖项类型', trigger: 'blur' },
                ],
            },
            isbtn:true


        }
    },
    created() {
    },
    methods: {
        handleChange(file, fileList) {
            // console.log(file,fileList)
            // console.log(this.ruleForm)
            this.ruleForm.picUrl = fileList;
        },
        handleRemove(file,fileList) {
            // console.log(file,fileList);
            this.ruleForm.picUrl = fileList;
        },
        handlePictureCardPreview(file) {
            this.dialogImageUrl = file.url;
            this.dialogVisible = true;
        },
        submitForm(formName, isPreview) {

            if(!this.isbtn){
                this.$message({
                    message: '请勿重复提交',
                    type: 'error'
                });
                
                return false
            }

            this.isbtn = false

            this.$refs[formName].validate((valid) => {
                if (valid) {
                    const obj = {...this.ruleForm};
                    obj.studentId = this.studentId;
                    if(!isPreview) {
                        let { studentId,type,name,degree,date,organizationalUnit,personalTeam,picUrl } = obj;
                        console.log(picUrl)
                        let params = new FormData();
                        params.append("studentId",studentId);
                        params.append("type",type);
                        params.append("name",name);
                        params.append("degree",degree);
                        params.append("date",date);
                        params.append("organizationalUnit",organizationalUnit);
                        params.append("personalTeam",personalTeam);
                        picUrl&&picUrl.forEach((value, index) =>{
                            console.log(value.raw)
                            params.append(`picUrl[${index}]`,value.raw);
                        })
                        // 存储竞赛信息
                            this.$ajax.post(this.G_acapi + this.ports.consultant.student.mine.competition.storeCompetitionInfo, params, {
                                headers: {
                                    token: window.sessionStorage.getItem('ymtxToken')
                                }
                            }).then((res) => {
                                if (res.data.code == 2000) {
                                    let id = res.data.data.id;
                                    this.isbtn = true;
                                    this.$router.push({path:'/consultant/minestudent/main/studentMessage/competition/detail',query:{id: id}})
                                }else{
                                    this.isbtn = true;
                                    this.$message({
                                    message: '请检查图片是否符合',
                                    type: 'error'
                                    });

                                }
                            }).catch((error) => {
                                 this.isbtn = true;
                                    this.$message({
                                    message: '请检查图片是否符合',
                                    type: 'error'
                                    });

                             }) 

                    }else {
                        this.isPreview = true;
                    }
                } else {
                    console.log('error submit!!');
                    return false;
                }
            });
        }
    },
}
</script>

<style scoped lang="less">
    .competitionAdd {
        .content {
            padding: 0 30px 30px 30px;
            background-color: #fff;
        }
        .line {
            margin-bottom: 20px;
        }
    }
</style>
<style lang="less">
.competitionAdd {
    input {
        border: 1px solid #EAEAEA;
        background-color: #FDFDFD;
    }
    .el-form-item {
        width: 410px;
        .el-select {
            width: 100%;
        }
    }

}
</style>